import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import './../styles/ProfilePage.css';
import { APIBaseLink } from '../components/APIBaseLink';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProfilePage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const API_BASE_LINK = APIBaseLink();

  const sendEmail = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_LINK}/user/resendVerificationEmail`, {
					method: "POST",
					headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            id: user.id,
          }),
				});

        if (response.ok) {
          toast.success("A Verification Email Has Been Sent To Your Inbox.");
					// Redirect to login after a short delay
        }
    } catch (error) {
      console.log(`Error: ${error}`);
      toast.error("Error Sending Verification Email.")
    }
  };

  return (
    <div className="profile-page">
      <h1>Profile</h1>
      <p><strong>First Name:</strong> {user.firstname}</p>
      <p><strong>Last Name:</strong> {user.lastname}</p>
      <p><strong>Email:</strong> {user.email}</p>
      <p><strong>Username:</strong> {user.username}</p>
      <p><strong>Role:</strong> {user.role}</p>
      <p><strong>Multi-Factor Authentication:</strong> {user.mfaEnabled? "Enabled" : "Disabled"}</p>
      <p><strong>Account Status:</strong> {user.verified? "Verified" : "Not Verified"}</p>
      { 
      !user.verified &&
        <button onClick={sendEmail} class="resend-button" >Verify Account</button>
      }

      {/* Edit Profile Button */}
      <div className="edit-profile-button-container">
        <button className="edit-profile-button" onClick={() => navigate('/edit-profile')}>
        <FontAwesomeIcon icon={faPencil} style={{color: "#283618",}} />
        </button>
      </div>
      
    </div>
  );
};

export default ProfilePage;
